import { BaseFetch } from "../main-model";
export default class LeaveModel extends BaseFetch {
  getLeaveBy = (data) =>
    this.authFetch({
      url: "leave/getLeaveBy",
      method: "POST",
      body: data,
    });
  getLeaveById = (data) =>
    this.authFetch({
      url: "leave/getLeaveById",
      method: "POST",
      body: data,
    });
  insertLeave = (data) =>
    this.authFetch({
      url: "leave/insertLeave",
      method: "POST",
      body: data,
    });
  updateLeaveById = (data) =>
    this.authFetch({
      url: "leave/updateLeaveById",
      method: "POST",
      body: data,
    });
  deleteLeaveById = (data) =>
    this.authFetch({
      url: "leave/deleteLeaveById",
      method: "POST",
      body: data,
    });
  updateLeaveStatusById = (data) =>
    this.authFetch({
      url: "leave/updateLeaveStatusById",
      method: "POST",
      body: data,
    });
}
